
import { defineComponent } from 'vue'

// types
import ActiveUserMixin, { DashboardContext } from '~/mixins/activeUserMixin'
import ContextMixin from '~/mixins/contextMixin'
import { getDefaultAvatar } from '~/utils/ui'

export default defineComponent({
  name: 'ContextSwitcher',
  mixins: [ActiveUserMixin, ContextMixin],
  props: {
    isCollapsed: Boolean
  },
  data() {
    return {
      searchCandidate: ''
    }
  },
  methods: {
    getDefaultAvatar,
    isActive(context: DashboardContext): boolean {
      return (
        (context.login === this.activeDashboardContext.login ||
          context.team_name === this.activeDashboardContext.team_name) &&
        context.vcs_provider === this.activeDashboardContext.vcs_provider
      )
    },
    providerIcon(vcsShortcode: string): string {
      return this.$providerMetaMap[vcsShortcode]?.icon ?? ''
    },
    filterByQuery(context: DashboardContext): boolean {
      const contextName = context.team_name || context.login
      return this.searchCandidate
        ? contextName.toLowerCase().includes(this.searchCandidate.toLowerCase())
        : true
    },
    resetSearch() {
      this.searchCandidate = ''
    },
    getTriggerButtonStyle(isOpen: boolean) {
      return this.isCollapsed ? 'hover:opacity-75 px-0' : isOpen ? 'bg-ink-200' : 'hover:bg-ink-200'
    },
    handleToggle(toggle: () => void) {
      toggle()
      this.resetSearch()
    },
    handleNavigation(contextOwnerId: number, close?: () => void) {
      close?.()
      this.resetSearch()
      this.updateDefaultContextAPI({ contextOwnerId })
    }
  },
  computed: {
    contextsByType() {
      if (this.searchCandidate) {
        const searchResults = this.viewer.dashboardContext.filter(this.filterByQuery)
        return searchResults.length
          ? [
              {
                type: 'all',
                contexts: searchResults
              }
            ]
          : []
      }

      const teamAccounts = this.viewer.dashboardContext.filter(
        (context: Record<string, string>) => context.type === 'team'
      )
      const personalAcounts = this.viewer.dashboardContext.filter(
        (context: Record<string, string>) => context.type === 'user'
      )

      const contexts = []

      if (teamAccounts.length)
        contexts.push({
          type: 'teams',
          contexts: teamAccounts
        })
      if (personalAcounts.length)
        contexts.push({
          type: 'personal',
          contexts: personalAcounts
        })
      return contexts
    },
    showAddAccountBtn(): boolean {
      // Check for superadmin status only if on prem, else true
      const canUserAddAccount = this.$config.onPrem ? this.isViewerSuperadmin : true

      return this.contextsByType.length > 0 && !this.searchCandidate && canUserAddAccount
    }
  },

  async fetch() {
    await Promise.all([
      this.fetchContext(),
      ...(this.$config.onPrem ? [this.fetchIsViewerSuperadmin()] : [])
    ])
  }
})
